import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const Label = styled.span`
  line-height: 1.4;
  font-size: 13px;
  letter-spacing: 0.01em;
  color: ${COLOR.SONIC_SILVER};
  font-weight: 600;
`;

export const Value = styled.span`
  word-break: break-all;
  font-weight: 600;
`;
